import React from 'react'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { Loading } from '../../Simple'
import { useLocation } from 'react-router-dom'
import { IoMdChatbubbles } from 'react-icons/io'
import { notAgend } from '../../../assets'
import { CompError, CompPedido } from '../../Complex/'
import { LocalStorage, Services } from '../../../services/'
import RouterHook from '../../../contexts/RouterHook'

import './stylesHF.css'
import { ChatContext } from '../../../contexts/ChatContext'
import { IoChevronBackOutline } from 'react-icons/io5'
import useHoraFixa from './HoraFixa.functions.ts'
import { Box } from '@mui/material'

export default function DesktopHF() {
  const arraySttRef = React.useRef(null)
  const location = useLocation()
  const serverRouter = RouterHook()
  const { loadAgend, sttCtxAgend } = React.useContext(AgendamentoContext)
  const { sttChatCtx, actionsChatCtx } = React.useContext(ChatContext)

  const { BuscarHoraFixaId, verificarAcessoUsuario, semAcesso } = useHoraFixa()

  React.useEffect(() => {
    if (location.pathname.split('/').pop() !== '') {
      BuscarHoraFixaId(location.pathname.split('/').pop()).then(horariosFixos => {
        verificarAcessoUsuario(horariosFixos)
      })
    }
  }, [])

  React.useEffect(() => {
    if (sttCtxAgend.horaFixaSelected !== null && arraySttRef.current !== null) {
      let idx = 0
      const now = new Date()

      for (let i = sttCtxAgend.horaFixaSelected.pedidos.length - 1; i >= 0; i--) {
        if (new Date(sttCtxAgend.horaFixaSelected.pedidos[i].dataInicio) < now) {
          idx = i
          break
        }
      }

      arraySttRef.current.children[idx].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }, [sttCtxAgend.horaFixaSelected])

  function ReturnColorStatus(status) {
    switch (status) {
      case 'Solicitado':
        return '#ff7043'
      case 'Agendado':
        return '#22ac4a'
      case 'Rejeitado':
        return '#bf3324'
      case 'Cancelado':
        return '#bf3324'
      case 'REALIZADO':
        return '#00cda4'
      default:
        return '#000000'
    }
  }

  function RetornaStatus(status) {
    switch (status) {
      case 'Solicitado':
        return 'SOLICITADO'
      case 'Agendado':
        return 'ATIVO'
      case 'Rejeitado':
        return 'INATIVO'
      case 'Cancelado':
        return 'INATIVO'
      default:
        return 'DESCONHECIDO'
    }
  }

  function AbrirChatPedido() {
    if (sttChatCtx.modeChat !== 'agendamentos') actionsChatCtx.handleModeChat('agendamentos')
    LocalStorage.set('chat-selected', {
      mode: 'agendamentos',
      id: sttCtxAgend.horaFixaSelected.pedidos[0].chat_idchat,
    })
    serverRouter('chat', sttCtxAgend.horaFixaSelected.pedidos[0].usuario_idusuario)
  }

  return (
    <>
      {loadAgend.horaFixa ? (
        <div className='contain-loading'>
          <Loading text={'Carregando agendamentos...'} />
        </div>
      ) : semAcesso ? (
        <CompError
          title='Horário Fixo não encontrado'
          message='O horário fixo que você está tentando acessar não existe.'
        />
      ) : (
        <>
          <div
            className='contain-page-checkout'
            style={{ width: 'calc(100% - 30px)', position: 'relative' }}
          >
            <h2 className='text-title-page tw-mb-3'>
              {' '}
              {`Horário Fixo #${location.pathname.split('/').pop()}`}{' '}
            </h2>
            <IoChevronBackOutline
              className='icon-back-page'
              onClick={() => {
                serverRouter('back')
              }}
              size={30}
            />
            <div className='contain-view-hora-fixa-desktop'>
              <div className='contain-list-clientes'>
                <div className='contain-resumo-hora-fixa'>
                  <h3
                    className='hf-text-normalize'
                    style={{
                      color: ReturnColorStatus(sttCtxAgend.horaFixaSelected.statusSolicitacao),
                      fontFamily: 'jost-mediun',
                    }}
                  >
                    {RetornaStatus(sttCtxAgend.horaFixaSelected.statusSolicitacao)}
                  </h3>
                  <h3 className='hf-title-dia'>
                    {Services.ReturnDiaSemana(
                      5,
                      new Date(sttCtxAgend.horaFixaSelected.dataPrimeiraReserva),
                    ).toUpperCase()}
                  </h3>
                  {sttCtxAgend.horaFixaSelected.pedidos.length > 0 ? (
                    <h3 className='hf-text-normalize'>
                      {Services.ReturnHoraMin(
                        new Date(sttCtxAgend.horaFixaSelected.pedidos[0].dataInicio),
                      ) + ' '}
                      às
                      {' ' +
                        Services.ReturnHoraMin(
                          new Date(sttCtxAgend.horaFixaSelected.pedidos[0].dataFinal),
                        )}
                    </h3>
                  ) : null}
                  {sttCtxAgend.horaFixaSelected.tipoMensalista !== null &&
                  sttCtxAgend.horaFixaSelected.tipoMensalista !== 'Indeterminado' ? (
                    <h3 className='hf-text-normalize'>
                      {Services.DataFormat(
                        'DD/MM/YY',
                        sttCtxAgend.horaFixaSelected.dataPrimeiraReserva,
                      ) + ' '}
                      à
                      {' ' +
                        Services.DataFormat(
                          'DD/MM/YY',
                          sttCtxAgend.horaFixaSelected.dataUltimaReserva,
                        )}
                    </h3>
                  ) : (
                    <h3 className='hf-text-normalize'>
                      {`Início em ${Services.DataFormat('DD/MM/YY', sttCtxAgend.horaFixaSelected.dataPrimeiraReserva)}`}
                    </h3>
                  )}
                  <div className='line-border-bottom' />
                  <div className='contain-view-empresa'>
                    <img
                      src={`${sttCtxAgend.horaFixaSelected.quadra.urlFoto}${sttCtxAgend.horaFixaSelected.quadra.foto}`}
                      alt='Quadra'
                      title={'Quadra ' + sttCtxAgend.horaFixaSelected.quadra.descricao}
                    />
                    <div className='contain-infos-empresa-usuario'>
                      <h2>{sttCtxAgend.horaFixaSelected.pedidos[0].empresa.nome}</h2>
                      <h3>{sttCtxAgend.horaFixaSelected.quadra.descricao}</h3>
                      <h3 style={{ fontSize: '14px' }}>
                        {sttCtxAgend.horaFixaSelected.quadra.endereco}
                      </h3>
                    </div>
                  </div>
                  <div className='line-border-bottom' />
                  <h3 className='hf-text-aviso'>
                    Os valores são atualizados automaticamente com base nos valores de cada
                    agendamento.
                  </h3>
                  <div className='contain-valor-recebido'>
                    {sttCtxAgend.horaFixaSelected.valorAtualizado !== null &&
                    sttCtxAgend.horaFixaSelected.valorAtualizado !== 0 ? (
                      <div className='contain-valor-line'>
                        <h3>Valor contratado</h3>
                        <h4
                          style={{ color: 'black' }}
                        >{`R$${sttCtxAgend.horaFixaSelected.valorAtualizado.toFixed(2).replace('.', ',')}`}</h4>
                      </div>
                    ) : (
                      <div className='contain-valor-line'>
                        <h3>Valor contratado</h3>
                        <h4
                          style={{ color: 'black' }}
                        >{`R$${sttCtxAgend.horaFixaSelected.valorTotal.toFixed(2).replace('.', ',')}`}</h4>
                      </div>
                    )}
                    {sttCtxAgend.horaFixaSelected.valorPrevisto !== null &&
                      sttCtxAgend.horaFixaSelected.valorPrevisto !== 0 &&
                      sttCtxAgend.horaFixaSelected.tipoMensalista !== 'Indeterminado' && (
                        <div className='contain-valor-line'>
                          <h3>Valor previsto</h3>
                          <h4
                            style={{ color: '#FFAD19' }}
                          >{`R$${sttCtxAgend.horaFixaSelected.valorPrevisto.toFixed(2).replace('.', ',')}`}</h4>
                        </div>
                      )}
                    {sttCtxAgend.horaFixaSelected.valorCancelado !== null &&
                      sttCtxAgend.horaFixaSelected.valorCancelado !== 0 && (
                        <div className='contain-valor-line'>
                          <h3>Valor cancelado</h3>
                          <h4
                            style={{ color: '#be3223' }}
                          >{`R$${sttCtxAgend.horaFixaSelected.valorCancelado.toFixed(2).replace('.', ',')}`}</h4>
                        </div>
                      )}
                    {sttCtxAgend.horaFixaSelected.valorRealizado !== null &&
                      sttCtxAgend.horaFixaSelected.valorRealizado !== 0 && (
                        <div className='contain-valor-line'>
                          <h3>Valor pago</h3>
                          <h4>{`R$${sttCtxAgend.horaFixaSelected.valorRealizado.toFixed(2).replace('.', ',')}`}</h4>
                        </div>
                      )}
                  </div>
                  {sttCtxAgend.horaFixaSelected.status ? (
                    sttCtxAgend.horaFixaSelected.tipoMensalista === 'Indeterminado' ? (
                      <h3 className='hf-text-aviso'>
                        Esse horário fixo é renovado semanalmente, ele não tem fim. Para cancelar,
                        contate o gestor do centro esportivo.
                      </h3>
                    ) : (
                      <h3 className='hf-text-aviso'>
                        Para cancelar esse horário fixo, contate o gestor do centro esportivo.
                      </h3>
                    )
                  ) : (
                    <></>
                  )}
                  {sttCtxAgend.horaFixaSelected.status && (
                    <button
                      className='btt-text-icon-cliente-cancel'
                      onClick={() => {
                        AbrirChatPedido()
                      }}
                    >
                      Abrir chat
                      <IoMdChatbubbles className='icon-btt-text-icon' />
                    </button>
                  )}
                </div>
              </div>
              <div ref={arraySttRef} className='contain-list-array-state'>
                {sttCtxAgend.horaFixaSelected.pedidos.length > 0 ? (
                  sttCtxAgend.horaFixaSelected.pedidos.map((item, index) => {
                    return (
                      <CompPedido
                        key={index}
                        pedido={item}
                        nome={sttCtxAgend.horaFixaSelected.usuario.nome}
                        onClick={() => {}}
                        fixo={true}
                        maxW={true}
                      />
                    )
                  })
                ) : (
                  <div className='contain-not-agend'>
                    <img
                      title='Sem Agendamentos para esse Horário Fixo'
                      src={notAgend}
                      alt='Not Agend'
                    />
                    <h2>{'O Cliente não possui Agendamentos para esse Horário Fixo'}</h2>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Box sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
            <div
              className='rtz-banner'
              data-rtz-espaco-id='119'
              style={{ width: '728px', height: '90px', overflow: 'hidden' }}
              data-rtz-width='728'
              data-rtz-height='90'
              title='Espaço publicitário'
              data-rtz-display-formato='imagem_video'
              data-rtz-tipo-criativo='360'
              data-rtz-device='desktop'
            ></div>
          </Box>
        </>
      )}
    </>
  )
}
